var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 " }, [
        _c("h3", { staticClass: "page-heading" }, [
          _vm._v(_vm._s(_vm.pagetitle ? _vm.pagetitle : "Coming Soon"))
        ]),
        _vm._v(" "),
        _vm.pagetitle == "Assets"
          ? _c("p", [_vm._v("For the specific project")])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "signup-content" }, [
      _c("h3", [_vm._v("COMING SOON")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0deefe1c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0deefe1c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/ComingSoon.vue
// module id = null
// module chunks = 